import { render, staticRenderFns } from "./dirVendorView.vue?vue&type=template&id=762e6f64&"
import script from "./dirVendorView.vue?vue&type=script&lang=js&"
export * from "./dirVendorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports